export const generateRandomId = () => {
    return crypto.randomUUID()
}
